module.exports = __webpack_public_path__ + "3fb08608bd4fa8855cc146441e5a7df1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/email_logo.png
// module id = 3149
// module chunks = 0